import { defineStore } from 'pinia'
import type { DeepPartial } from '@apollo/client/utilities'
import { ProfileInfoDocument, type User } from '~/apollo/gql/graphql'

export const useAuthStore = defineStore('auth', () => {
  const loggedIn = ref(false)
  const loggedUser = ref<DeepPartial<User>>()

  const { onLogout } = useApollo()
  const toast = useToast()

  const setUser = (user: DeepPartial<User>) => {
    loggedUser.value = user
  }

  const refetchProfile = async () => {
    try {
      const { data } = await useAsyncQuery(ProfileInfoDocument)

      loggedUser.value = data.value?.profileInfo

      return loggedUser.value
    } catch (error) {
      console.error(error)
      toast.add({
        color: 'red',
        title: 'Gagal mengambil data user!',
        description: 'Silahkan coba beberapa saat lagi.'
      })

      logout()
    }
  }

  const logout = async () => {
    loggedIn.value = false
    loggedUser.value = undefined

    await onLogout()

    navigateTo('/')
  }

  return {
    loggedIn,
    loggedUser,

    logout,
    setUser,
    refetchProfile
  }
})

// if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
